// --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- ---
// MARK: - AI Area
export class AreaThreads {
    // --- --- --- --- --- --- --- --- --- ---
    // MARK: - Constructor
    constructor(dataCore) {
        this.dataCore = dataCore;
    }
    // --- --- --- --- --- --- --- --- --- ---
    // MARK: - Read
    /**
     * Gets the messages for a specific thread.
     * @param threadId - The ID of the thread.
     * @returns An array of ThreadMessage objects.
     */
    async getMessages(threadId) {
        return this.dataCore.getThreadMessageList(threadId);
    }
    // --- --- --- --- --- --- --- --- --- ---
    // MARK: - Write
    /**
     * Creates a new message in a specific thread.
     * @param threadId - The ID of the thread.
     * @param input - The input for the message.
     * @returns A new ThreadMessage object.
     */
    async createMessage(threadId, input) {
        return this.dataCore.createThreadMessage(threadId, input);
    }
    /**
     * Creates a new message reaction in a specific thread.
     * @param threadId - The ID of the thread.
     * @param input - The input for the message reaction.
     * @returns A new ThreadMessageReaction object.
     */
    async createMessageReaction(threadId, input) {
        return this.dataCore.createThreadMessageReaction(threadId, input);
    }
    /**
     * Removes a message reaction from a specific thread.
     * @param threadId - The ID of the thread.
     * @param input - The input for the message reaction.
     * @returns A new ThreadMessageReaction object.
     */
    async removeMessageReaction(threadId, input) {
        return this.dataCore.removeThreadMessageReaction(threadId, input);
    }
    /**
     * Finalizes a message in a specific thread.
     * @param threadId - The ID of the thread.
     * @param input - The input for the thread.
     * @returns Finalize input
     */
    async finalizeMessage(threadId, input) {
        return this.dataCore.finalizeThreadMessage(threadId, input);
    }
}
